import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  searchWrapper: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    padding: '5px 20px',
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid #CCCCCC',
    borderRadius: 4,
    paddingLeft: '18px',
    [theme.breakpoints.down('xs')]: {
      padding: '6px 10px',
    },
  },
  searchInput: {
    fontSize: '0.9rem',
    backgroundColor: 'faff',
    border: 'none',
    width: '100%',
    fontFamily: 'Montserrat, sans-serif',
    '&:focus': {
      outline: 'none',
    },
    '&:before, &:after': {
      border: '0 !important',
    },
  },
  searchBtn: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
}));

export default useStyles;
